'use client'

import dynamic from 'next/dynamic'
import EventGrid from '../EventGrid'

import { Skeleton } from '@/components/ui/skeleton'
import { useEventsContext } from '@/providers/EventsProvider'

// Code-split so @vis.gl/react-google-maps (and the Maps JS it pulls in) stays
// out of the events pages' initial bundle.
const ExploreEventsMap = dynamic(() => import('../ExploreEventsMap'), {
  ssr: false,
  loading: () => <Skeleton className="col-span-full h-80 w-full rounded-xl sm:h-96" />,
})

/**
 * Main content area of the events explore view: the events map (unless the
 * virtual-only format filter is active) above the event grid.
 */
export const ExploreMain: React.FC = () => {
  const { format } = useEventsContext()
  return (
    <div className="grid auto-rows-auto grid-cols-1 gap-4 lg:gap-5 xl:gap-8">
      {format !== 'virtual' && <ExploreEventsMap />}
      <EventGrid />
    </div>
  )
}
